/**
 * How the API and the console talk — facts both ends must agree on. No zod here: the web client
 * reads this from its eager chunk (`lib/trpc.ts`), so it is its own subpath rather than a barrel
 * import that would drag the schema library along. `./personDisplay.ts` says why that matters.
 */

/**
 * The most procedure calls one HTTP request may batch.
 *
 * The API's `maxBatchSize` refuses more, and the console's batch link uses it as `maxItems`, so a
 * busy page is split into several requests rather than refused. Every call in a batch runs
 * concurrently, and a login costs 64 MiB of argon2 on a 512 MB machine: the per-IP guess budget
 * bounds how many logins get through, but only this bounds the size of the request asking.
 */
export const TRPC_MAX_BATCH_SIZE = 20;
